import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { GoogleMap } from "@angular/google-maps";
import { AddressBo } from "./google-map.model";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-google-map",
  templateUrl: "./google-map.component.html",
  styleUrls: ["./google-map.component.scss"],
})
export class GoogleMapComponent implements OnInit {
  @Input() AddressBo: AddressBo = new AddressBo();
  @Input() addressType: string = "address";
  autocompleteInput: string;
  @Output() GoogleMapEmit = new EventEmitter<any>();
  @ViewChild("addresstext") addresstext: any;
  @ViewChild(GoogleMap)
  GoogleMap: google.maps.Map;
  latitude: any = "";
  longitude: any = "";
  marker: google.maps.Marker;
  constructor(public toasterService: ToastrService) {
  }
  ngOnInit(): void {
    this.loadGoogleMapsScript();
  }
  loadGoogleMapsScript() {

    const script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAOJA0XHRtR49T4Y4WNzEZXUouGoe9-XlI&libraries=places"
    script.async = true;
    document.head.appendChild(script);
    script.onload = () => {
      this.getPlaceAutocomplete();
    };
  }
  //............................................getPlaceAutocomplete........................................
  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addresstext.nativeElement,
      {
        // componentRestrictions: { country: ["fr", "ch", "be", "IN", "US"] },
        types: [this.addressType], // 'establishment' / 'address' / 'geocode'
      }
    );
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const place = autocomplete.getPlace();
      this.AddressBo.address_components = place.address_components;
      this.AddressBo.formatted_address = place.formatted_address;
      this.latitude = place.geometry.location.lat();
      this.longitude = place.geometry.location.lng();

      this.AddressBo.clientLocationLatitude =this.latitude;
      this.AddressBo.clientLocationLongitude = this.longitude
      this.getAddressForSpecificClickGoogleMap()
    });
  }
  //............................................getAddressForSpecificClickGoogleMap........................................
  getAddressForSpecificClickGoogleMap() {
    const mapOptions: google.maps.MapOptions = {
      center: { lat: this.latitude, lng: this.longitude },
      zoom: 12,
    };
    this.GoogleMap = new google.maps.Map(
      document.getElementById("map"),
      mapOptions
    );
    this.marker = new google.maps.Marker({
      position: { lat: this.latitude, lng: this.longitude },
      map: this.GoogleMap,
      icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
    });
    this.GoogleMap.addListener("click", (event: google.maps.MouseEvent) => {
      this.latitude = event.latLng.lat()
      this.longitude = event.latLng.lng()
      this.getAddressFromMarker(event.latLng);
    });
  }
  //............................................getAddressFromMarker........................................
  getAddressFromMarker(latLng: google.maps.LatLng) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      this.marker = new google.maps.Marker({
        position: { lat: this.latitude, lng: this.longitude },
        map: this.GoogleMap,
        icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
      });
      if (status === "OK") {
        if (results[0]) {

          this.AddressBo.formatted_address = results[0].formatted_address;
          this.AddressBo.clientLocationLatitude =latLng.lat();
          this.AddressBo.clientLocationLongitude = latLng.lng();
          this.autocompleteInput = results[0].formatted_address;
        } else {
          results[0].formatted_address = "Address not found";
        }
      } else {
        results[0].formatted_address = "Geocoder failed due to: " + status;
      }
    });
  }
  //............................................placeMarker........................................
  placeMarker(location: google.maps.LatLng) {
    if (this.marker) {
      this.marker.setPosition(location);
    } else {
      this.marker = new google.maps.Marker({
        position: location,
        map: this.GoogleMap,
        icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
      });
    }
  }
  //............................................CopyAddresstoPrePopulate........................................
  CopyAddresstoPrePopulate() {
    this.toasterService.success("Address Copied Successfully");
    this.AddressBo.isChanged = true;
    this.GoogleMapEmit.emit(this.AddressBo);
  }
}



// if (
//   place.formatted_address == undefined ||
//   place.formatted_address == null ||
//   place.address_components == undefined ||
//   place.address_components == null
// ) {
//   //
// } else {
// }
// const loader = document.getElementById("loader");
// if (loader) {
//   loader.style.display = "block";
// }
// const loader = document.getElementById("loader");
// if (loader) {
//   loader.style.display = "block";
// }